export type GAItemListInfo = {
   item_list_name?: string;
   item_list_id?: LIST_TYPE;
   item_list_length?: number;
   index?: number;
};

export type GAItemProduct = {
   item_id?: string;
   item_name?: string;
   item_brand?: string | null;
   item_category?: string | null;
   item_category2?: string | null;
   item_category3?: string | null;
   price?: number | null;
   unit_size?: string;
   stock_status?: string | undefined;
   callout?: string[];
   promotionTypes?: string[];
   voucherifyIds?: string[];
   m3_discount?: string;
};

export type GAItem = GAItemListInfo &
   GAItemProduct & {
      quantity?: number;
   };

type GAECommerceObject = {
   currency?: "NOK";
   quantity?: number;
   coupon?: string | null;
   transaction_id?: string;
   value?: number | null;
   deliveryFee?: number;
   items?: GAItem[];
   num_items?: number;
};

export type GAClaim = {
   orderNumber: string;
   lines: GAClaimProductLine[];
};
export type GAClaimProductLine = {
   sku: string;
   cause_code: string;
   cause_description: string;
};

export type GAAddtionalData = GAOrderEvent & {
   ecommerce?: GAECommerceObject & GAItemListInfo;
   creative_slot?: string;
   creative_name?: string;
   creative_type?: string;
   link_url?: string;
   link_slot?: string;
   link_name?: string;
   button_name?: string;
   items?: GAItem[];
   search_term?: string;
   search_type?: string;
   search_results?: number;
   filter_type?: string;
   filter_content?: string;
   method?: string;
   modal_name?: string;
   error_context?: string;
   error_text?: string;
   signup_name?: string;
   value?: number;
   _clear?: boolean;
   accordion_title?: string;
   accordion_category?: string;
   claim?: GAClaim;
};

type GAOrderEvent = {
   order_type?: string;
   action?: string;
   order_interval?: number;
   order_class?: string;
};

export type GAListInformation = {
   type: LIST_TYPE;
   name: string;
   length?: number;
};

export enum LIST_TYPE {
   CATEGORY = "category",
   CUSTOM = "custom",
   SEARCH = "search",
   CART = "cart",
   AVAILABILITY_CHECK = "availability_check",
   FAVORITES = "favorites",
   ORDER = "order",
   RELATED_PRODUCTS = "related_products",
   BARCODE = "barcode",
   RECOMMENDATIONS = "recommendations",
   CONTRACTUAL_PRODUCTS = "contractual_products",
   RECIPE = "recipe",
   EXPIRED = "expired",
   EXPIRED_FAVORITES = "expired_favorites",
   EXPIRED_SUBSCRIPTION = "expired_subscription",
   SUBSCRIPTION_PRODUCTS = "subscription_products",
   LAST_CHANCE = "last_chance"
}

export type TrackingInfo = {
   context: string;
   text: string;
};

export type PosthogProduct = {
   product_id: string;
   sku: string;
   name: string;
   category?: string;
   brand?: string;
   price?: number;
   quantity?: number;
   coupon?: string;
   position?: number;
   creative_name?: string;
   url?: string;
   image_url?: string;
   variant?: string;
   labels?: string[];
};

export type PosthogOrderCompleted = {
   checkout_id?: string;
   order_id: string;
   affiliation?: string;
   subtotal?: number;
   total?: number;
   revenue?: number;
   tax?: number;
   shipping?: number;
   discount?: number;
   coupon?: string;
   currency?: string;
   products: PosthogProduct[];
};

export type PostHogProductOrderCompleted = PosthogProduct & {
   order_id: string;
};

export type PosthogEventName = "Order Completed";
